module.exports = __webpack_public_path__ + "static/media/coming-soon-background.72f73c59.png";